<div class="row" style="width:100%;margin:0 auto;">
  <div class="col-12">
    <mdb-card>
      <mdb-card-header class="bg-white">
        <div class="headerCover">
          <div class="headerTilte app_list_header">
            <h5 class="m-0" class="mainHeadingStyle">{{reportHeading}}</h5>
          </div>
          <div class="headerButtons">
            <mat-label class="matlabel"><br>
              <!-- <div class="d-flex justify-content-end" style="width:95%;" *ngIf="docbackbutton">
              <img src="../../../assets/ui_icons/buttons/Back_button.svg" width="85px" (click)="backpage()">
                </div> -->
              <!-- <img src="../../../assets/ui_icons/buttons/Back_button.svg" class="saveimgbtn_inpatinfo" (click)="todisplaycoverdiv()" *ngIf="backbutton"/> -->
              <img src="../../../assets/ui_icons/buttons/back_icon.svg" style="width:30px;margin-right: 5px;"
                (click)="todisplaycoverdiv()" *ngIf="backbutton" />
              <a style="margin:0 5px;" (click)="print_area()"><img src="../../../assets/img/printer.svg"
                  class="backimgbtn_inpatinfo" style="width: 25px; height: 25px;" *ngIf="backbutton" /></a>
              <img src="../../../assets/ui_icons/buttons/XL_export.svg" class="saveimgbtn_inpatinfo"
                (click)="getExcelData('excel')" style="margin-right:10px" *ngIf="backbutton" />

            </mat-label>
          </div>
          <!-- <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2">
            
          </div> -->
        </div>
      </mdb-card-header>
      <mdb-card-body>
        <div class="cover_div" style="padding-bottom: 13px;" *ngIf="forcoverdiv">
          <div class="header_lable">
            {{reportHeading}} Details
          </div>
          <div class="content_cover">
            <div class="row">
              <div *ngIf="scheduleFlag" class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                <mat-label class="matlabel">Schedule type<br>
                  <mat-select class="ipcss widthappt" [(ngModel)]="scheduleType" multiple>
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let schedule of scheduleList" value={{schedule.schedule_type_id}}>
                      {{schedule.category}}</mat-option>
                  </mat-select>
                </mat-label>
              </div>

              <!-- added my me -->
              <div *ngIf="srd_flag" class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 select_bottom">
                <mat-label class="matlabel">Filter by<br>
                  <select [(ngModel)]="Filter_by_Id" class="ipcss" (change)="filterby()">
                    <option value="Doctor" selected>Doctor</option>
                    <option value="Speciality">Speciality</option>
                    <option value="Service">Charge</option>
                  </select>
                </mat-label>
              </div>
              <!-- ended my me -->

              <!----addded for Bed Occupancy start-------->
              <div *ngIf="bed_occupancyflag" class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 select_bottom">
                <mat-label class="matlabel">Filter by<br>
                  <select [(ngModel)]="bed_occupancyfilter" class="ipcss" (change)="wardbedfilterby()">
                    <option value="ward" selected>Ward</option>
                    <option value="bed">Bed</option>
                  </select>
                </mat-label>
              </div>
              <!--added for Bed Occupancy end--->
              <!-----------Product wise start---------------------->
              <div *ngIf="productflag" class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 select_bottom">
                <mat-label class="matlabel">Filter by<br>
                  <select [(ngModel)]="productfilter" class="ipcss" (change)="productfilterby()">
                    <option value="product" selected>Product </option>
                    <option value="product Type">Product Type</option>
                  </select>
                </mat-label>
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2" *ngIf="product_medicine_name_flag">
                <mat-label class="matlabel">Product Type<br>
                  <input type="text" class="ipcss" maxlength="50" (keyup)="medicineData_name(product_medicine_name)"
                    [(ngModel)]="product_medicine_name" matInput [matAutocomplete]="auto1" />
                  <mat-autocomplete #auto1="matAutocomplete" [panelWidth]="'auto'">
                    <mat-option (click)="select_refer_medicine(item)" *ngFor="let item of ReferedmedicineArray"
                      value="{{item.med_code}}">
                      {{item.med_name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-label>
              </div>

              <!-----------------Product wise end---------------->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 select_bottom" *ngIf="doctorFlag">
                <mat-label class="matlabel" [(ngModel)]="fieldtype"> {{ fieldtype }} <br>
                  <select [(ngModel)]="doctorId" class="ipcss" (change)="selectedText()">
                    <!-- <option value="All">All</option> -->
                    <option *ngFor="let data of doctorList" value={{data.id}}>{{data.name}}</option>
                  </select>
                </mat-label>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 select_bottom" *ngIf="surgdoctorFlag">
                <mat-label class="matlabel" [(ngModel)]="fieldtype"> {{ fieldtype }} <br>
                  <select [(ngModel)]="doctorId" class="ipcss" (change)="selectedText()">
                    <!-- <option value="All">All</option> -->
                    <option *ngFor="let data of doctorList" value={{data.id}}>{{data.name}}</option>
                  </select>
                </mat-label>
              </div>


              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 select_bottom" *ngIf="doctorFlag">
                <mat-label class="matlabel">Patient type<br>
                  <select [(ngModel)]="pattype" class="ipcss">
                    <option value="All">All</option>
                    <option value="out-pat">OP</option>
                    <option value="in-pat">IP</option>
                  </select>
                </mat-label>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 select_bottom" *ngIf="pattyperepoFlag">
                <mat-label class="matlabel">Patient type<br>
                  <select [(ngModel)]="pattyperepo" class="ipcss">
                    <option value="All">All</option>
                    <option value="out-pat">OP</option>
                    <option value="in-pat">IP</option>
                  </select>
                </mat-label>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 select_bottom" *ngIf="userFlag">
                <mat-label class="matlabel"> User <br>
                  <select [(ngModel)]="userId" class="ipcss" (change)="selectedText()">
                    <option value="All">All</option>
                    <option *ngFor="let data of userList" value={{data.id}}>{{data.name}}</option>
                  </select>
                </mat-label>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 select_bottom">
                <mat-label class="matlabel">Duration<br>
                  <select [(ngModel)]="filtduration" class="ipcss">
                    <option value="select">Select</option>
                    <option value="7">1 week</option>
                    <option value="30">1 month</option>
                    <option value="91">3 months</option>
                    <option value="183">6 months</option>
                    <option value="365">1 year</option>
                  </select>
                </mat-label>
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2">
                <mat-label class="matlabel" style="margin-top: 7px;">From
                  <input type="date" class="ipcss_date " (change)="selectDate(fromDate,'1')" [(ngModel)]="fromDate"
                    max="{{currentDate}}" #matInput style="width: 140px;">
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2">
                <mat-label class="matlabel" style="margin-top: 7px;">To
                  <input type="date" class="ipcss_date " (change)="selectDate(toDate,'2')" [(ngModel)]="toDate"
                    #matInput style="width: 140px;">
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2">
                <mat-label class="matlabel"><br>
                  <img src="../../../assets/ui_icons/buttons/search_button.svg" class="saveimgbtn_inpatinfo"
                    (click)="getSalesData()" />
                </mat-label>
              </div>
            </div>
          </div>
        </div>

        <div
          style="box-shadow: 0 0 2px 0 ;
        background: inherit;
        backdrop-filter: blur(10px);border: 1px solid #66b9eb;border-radius: 5px;padding: 1px 20px 5px 20px;margin-top:5px"
          *ngIf="amountcard">
          <!-- border: .01rem solid #e0e1ed -->
          <div style="margin-top: 5px;" class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto"
              *ngIf="reportType == 'salesGst' || reportType == 'SDI'">
              <mat-label class="matlabel" style="margin-top: 7px;" *ngIf="totalAmount == 'NaN' ? '0.00' : totalAmount"
                #printsalesamountgst id="printsalesamountgst"><span style="font-weight: 600;">Sales Amount :
                </span> {{totalAmount}}
              </mat-label>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto"
              *ngIf="reportType == 'HBR' || reportType == 'DBR' || reportType == 'CHBR'">
              <mat-label class="matlabel" style="margin-top: 7px;" *ngIf="totalAmount == 'NaN' ? '0.00' : totalAmount"
                #totalamount id="totalamount"><span style="font-weight: 600;">Total : </span> {{totalAmount}}
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto"
              *ngIf="reportType == 'HBR'|| reportType == 'DBR'|| reportType == 'salesGst' || reportType == 'SDI' || reportType == 'CHBR'">
              <mat-label class="matlabel" style="margin-top: 7px;" *ngIf="cashAmount == 'NaN' ? '0.00' : cashAmount"
                #cashamount id="cashamount"><span style="font-weight: 600;">Cash : </span>
                {{cashAmount}}
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto"
              *ngIf="reportType == 'HBR'|| reportType == 'DBR'|| reportType == 'salesGst' || reportType == 'SDI' || reportType == 'CHBR'">
              <mat-label class="matlabel" style="margin-top: 7px;" *ngIf="cardAmount == 'NaN' ? '0.00' : cardAmount"
                #cardamount id="cardamount"><span style="font-weight: 600;">Card : </span>
                {{cardAmount}}
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto"
              *ngIf="reportType == 'HBR' || reportType == 'DBR'|| reportType == 'salesGst' || reportType == 'SDI' || reportType == 'CHBR'">
              <mat-label class="matlabel" style="margin-top: 7px;" *ngIf="insureAmount == 'NaN' ? '0.00' : insureAmount"
                #insureamount id="insureamount"><span style="font-weight: 600;">Insurance :
                </span> {{insureAmount}}
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto"
              *ngIf="reportType == 'HBR' || reportType == 'DBR'|| reportType == 'salesGst' || reportType == 'SDI' || reportType == 'CHBR'">
              <mat-label class="matlabel" style="margin-top: 7px;" *ngIf="upiAmount == 'NaN' ? '0.00' : upiAmount"
                #upiamount id="upiamount"><span style="font-weight: 600;">UPI:</span>
                {{upiAmount}}
              </mat-label>
            </div>
          </div>
        </div>
        <p class="nodata" *ngIf="salesList.length == 0">No records found</p>

        <div [hidden]="true">
          <table style="margin-left:10px;margin-right: 10px;" #printimage id="printimage">
            <tr>
              <td>
                <img alt="image" src={{hospital_logo}}>
              </td>
            </tr>
          </table>
          <div style="position: relative;top: 20px;left: 10px;text-align: left;" #hospitalwithnamelogo
            id="hospitalwithnamelogo">
            <span><b>{{hosp_name}}</b>,</span><br />
            <span *ngIf="hosp_addr != ''">{{hosp_addr}}</span><br />
            <span>{{hosp_csz}}</span><br />
            <span *ngIf="hosp_tel != undefined"><img src="../../../assets/img/phone.png" width="15px"
                height="15px" />{{hosp_tel}}.</span><br>
          </div>
        </div>

        <div class="table-responsive cover_div"
          [ngStyle]="{'width': applystyle ? '100%' : '50%','height': applyheight ? '65vh':'65vh'}"
          *ngIf="salesList.length != 0">
          <table #printsalesGST *ngIf="reportType == 'salesGst'" id="printsalesGST"
            style="font-size: 12px; width: 110%;">
            <thead>
              <tr>
                <th>Order no</th>
                <th>Order Date</th>
                <th style="width: 150px;">Product Name</th>
                <th>Batch No</th>
                <th>Quantity</th>
                <th>Amount</th>
                <th>cgst</th>
                <th>sgst</th>
                <th>Total CGST</th>
                <th>Total SGST</th>
                <th>GST Excluded</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.order_id}}</td>
                <td>{{sales.order_date}}</td>
                <td class="align_left" style="width: 150px;">{{sales.product_name}}</td>
                <td>{{sales.batch_no}}</td>
                <td>{{sales.quantity}}</td>
                <td style="text-align: right;">{{sales.amount}}</td>
                <td>{{sales.cgst}}</td>
                <td>{{sales.sgst}}</td>
                <td>{{sales.Total_CGST}}</td>
                <td>{{sales.Total_SGST}}</td>
                <td>{{sales.GST_excluded}}</td>
              </tr>
            </tbody>
          </table>

          <table #printStockRec *ngIf="reportType == 'stockReceivable'" id="printStockRec"
            style="font-size: 12px; width: 130%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th style="width:150px">Invoice no</th>
                <th style="width:150px">Product Name</th>
                <th style="width:100px">Batch No</th>
                <th>Qty Received Date</th>
                <th>Total Qty</th>
                <th>MRP Value</th>
                <th>MRP</th>
                <th>CGST/SGST</th>
                <th>CGST/SGST Price</th>
                <th>SGST Value</th>
                <th>Total SGST</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.invoice_no}}</td>
                <td class="align_left" style="width:150px">{{sales.product_name}}</td>
                <td>{{sales.batch_no}}</td>
                <td>{{sales.qty_received_date}}</td>
                <td>{{sales.total_qty}}</td>
                <td>{{sales.mrp_value}}</td>
                <td>{{sales.mrp}}</td>
                <td>{{sales.cgst}}</td>
                <td>{{sales.sgst_price}}</td>
                <td>{{sales.sgst_value}}</td>
                <td>{{sales.total_gst}}</td>
              </tr>
            </tbody>
          </table>

          <table #printgsd *ngIf="reportType == 'gsd'" id="printgsd" style="font-size: 12px; width: 140%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Order No</th>
                <th>Order Date</th>
                <th>Product Name</th>
                <th style="width:150px;text-align: left">Doctor Name</th>
                <th style="width:150px;text-align: left">Patient Name</th>
                <th>Batch No</th>
                <th style="text-align: left;">Supplier/Manufacturer</th>
                <th>Schedule Type</th>
                <th>Quantity Sold</th>
                <th>Expiry Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.order_id}}</td>
                <td>{{sales.order_date}}</td>
                <td class="align_left">{{sales.product_name}}</td>
                <td class="align_left" style="width:150px">{{sales.doctor_name}}</td>
                <td class="align_left" style="width:150px">{{sales.delivered_person}}</td>
                <td>{{sales.batch_no}}</td>
                <td style="text-align: left;">{{sales.supplier}}</td>
                <td>{{sales.category}}</td>
                <td>{{sales.qty_sold}}</td>
                <td>{{sales.expiry_date}}</td>
              </tr>
            </tbody>
          </table>

          <table #printSDI *ngIf="reportType == 'SDI'" id="prinSDI" style="font-size: 12px; width: 110%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Order No</th>
                <th>Order Date</th>
                <th style="width: 150px;">Product Name</th>
                <th>Batch No</th>
                <th style="width: 180px;text-align:left">Manufacturer Name</th>
                <th>Qty Sold</th>
                <th>Reminding Qty</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.order_id}}</td>
                <td>{{sales.order_date}}</td>
                <td class="align_left">{{sales.product_name}}</td>
                <td>{{sales.batch_no}}</td>
                <td style="width: 180px;text-align:left">{{sales.mfg_name}}</td>
                <td>{{sales.sold_qty}}</td>
                <td>{{sales.qty_hand}}</td>
                <td>{{sales.amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printHBR *ngIf="reportType == 'HBR'" id="printHBR" style="font-size: 12px; width: 140%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th style="width:75px">Bill No</th>
                <!-- <th style="width:125px">Created By</th> -->
                <th style="width:125px;text-align: left;">Created Date</th>
                <th>Paitent Name</th>
                <th *ngIf=" this.Filter_by_Id == 'Doctor' ">Doctor</th>
                <th *ngIf="this.Filter_by_Id == 'Speciality'">Speciality</th>
                <th *ngIf="this.Filter_by_Id == 'Service'">Charge</th>
                <th>Bill Amt</th>
                <th>Discount</th>
                <th>Paid</th>
                <th>Cash</th>
                <th>Card</th>
                <th>UPI</th>
                <th>Insurance</th>
                <th>Due/Credit</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td style="width:75px">{{sales.billing_id}}</td>
                <!-- <td class="align_left" style="width:150px">{{sales.user_name}}</td> -->
                <td style="width:125px;text-align: left;">{{sales.created_date}}</td>
                <td class="align_left">{{sales.patient_name}}</td>
                <td class="align_left">{{sales.doc_name}}</td>
                <td>{{sales.bill_amount}}</td>
                <td>{{sales.discount}}</td>
                <td>{{sales.paid_amount}}</td>
                <td>{{sales.cash}}</td>
                <td>{{sales.card}}</td>
                <td>{{sales.upi}}</td>
                <td>{{sales.insurance}}</td>
                <td>{{sales.balance}}</td>
                <td>{{sales.paid}}</td>
              </tr>
            </tbody>
          </table>

          <table #printchargetable *ngIf="reportType == 'HBR' && chargeList.length!=0" id="printchargetable" style="margin-top: 20px;width:100%;font-size: 12px;position: relative;
            left: 20%;">
            <thead>
              <tr>
                <td>S.No</td>
                <th>Charge type</th>
                <th>Bill amount</th>
                <th>Paid amount</th>
                <th>Cash</th>
                <th>Card</th>
                <th>UPI</th>
                <th>Cheque</th>
                <th>Insurance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let charge of chargeList">
                <td>{{charge.sno}}</td>
                <td style="text-align: left;">{{charge.charge}}</td>
                <td>{{charge.billamt}}</td>
                <td>{{charge.paidamt}}</td>
                <td>{{charge.cash}}</td>
                <td>{{charge.card}}</td>
                <td>{{charge.upi}}</td>
                <td>{{charge.cheque}}</td>
                <td>{{charge.insurance}}</td>
              </tr>
            </tbody>
          </table>

          <table #printusertable *ngIf="reportType == 'HBR' && userdataList.length !=0" id="printusertable" style="margin-top: 20px;width:100%;font-size: 12px;position: relative;
          left: 20%;">
            <thead>
              <tr>
                <td>S.No</td>
                <th>User Name</th>
                <th>Bill</th>
                <th> Cash</th>
                <th>Card</th>
                <th>UPI</th>
                <th>Cheque</th>
                <th>Insurance</th>
                <th>Due/Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of userdataList">
                <td>{{user.sno}}</td>
                <td>{{user.username}}</td>
                <td>{{user.bill}}</td>
                <td>{{user.cash}}</td>
                <td>{{user.card}}</td>
                <td>{{user.upi}}</td>
                <td>{{user.cheque}}</td>
                <td>{{user.insurance}}</td>
                <td>{{user.balance}}</td>
              </tr>
            </tbody>
          </table>

          <!------added by christo------->
          <div class="accordion" id="accordionExample" *ngIf="consoldatedreport">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <span class="reportsheanding">Hospital bill report</span>
                <button class="accordion-button collapsed" style="background: inherit;" type="button"
                  data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false"
                  aria-controls="collapseOne" (click)="conbillstyle()">

                  <div class="accordinamountcard">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label #printCRHBRtotal id="printCRHBRtotal" class="matlabel" style="margin-top: 7px;"
                          *ngIf="doctotalAmount == 'NaN' ? '0.00' : doctotalAmount"><span
                            style="font-weight: 600;">Total : </span> {{doctotalAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label #printCRHBRcash id="printCRHBRcash" class="matlabel" style="margin-top: 7px;"
                          *ngIf="doccashAmount == 'NaN' ? '0.00' : doccashAmount"><span style="font-weight: 600;">Cash :
                          </span>
                          {{doccashAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label #printCRHBRcard id="printCRHBRcard" class="matlabel" style="margin-top: 7px;"
                          *ngIf="doccardAmount == 'NaN' ? '0.00' : doccardAmount"><span style="font-weight: 600;">Card :
                          </span>
                          {{doccardAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label #printCRHBRinsurance id="printCRHBRinsurance" class="matlabel"
                          style="margin-top: 7px;" *ngIf="docinsureAmount == 'NaN' ? '0.00' : docinsureAmount"><span
                            style="font-weight: 600;">Insurance :
                          </span> {{docinsureAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label #printCRHBRupi id="printCRHBRupi" class="matlabel" style="margin-top: 7px;"
                          *ngIf="docupiAmount == 'NaN' ? '0.00' : docupiAmount"><span
                            style="font-weight: 600;">UPI:</span>
                          {{docupiAmount}}
                        </mat-label>
                      </div>
                    </div>
                  </div>
                </button>
              </h2>

              <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample" [ngClass]="{'success': isSuccessful, 'error': !isSuccessful}">
                <div class="accordion-body">
                  <table #printCRHBR id="printCRHBR" *ngIf="reportType == 'CR'" style="font-size: 12px;">
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th style="width:75px">Bill No</th>
                        <th style="width:125px">Created By</th>
                        <th style="width:125px;text-align: left;">Created Date</th>
                        <th>Paitent Name</th>
                        <th *ngIf=" this.Filter_by_Id == 'Doctor' ">Doctor</th>
                        <th *ngIf="this.Filter_by_Id == 'Speciality'">Speciality</th>
                        <th *ngIf="this.Filter_by_Id == 'Service'">Charge</th>
                        <th>Bill Amt</th>
                        <th>Paid</th>
                        <th>Cash</th>
                        <th>Card</th>
                        <th>UPI</th>
                        <th>Insurance</th>
                        <th>Due/Credit</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let sales of salesList">
                        <td>{{sales.sno}}</td>
                        <td style="width:75px">{{sales.billing_id}}</td>
                        <td class="align_left" style="width:150px">{{sales.user_name}}</td>
                        <td style="width:125px;text-align: left;">{{sales.created_date}}</td>
                        <td class="align_left">{{sales.patient_name}}</td>
                        <td class="align_left">{{sales.doc_name}}</td>
                        <td>{{sales.bill_amount}}</td>
                        <td>{{sales.paid_amount}}</td>
                        <td>{{sales.cash}}</td>
                        <td>{{sales.card}}</td>
                        <td>{{sales.upi}}</td>
                        <td>{{sales.insurance}}</td>
                        <td>{{sales.balance}}</td>
                        <td>{{sales.paid}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table #printCRHBRusertable id="printCRHBRusertable" *ngIf="reportType == 'CR'"
                    style="margin-top: 20px;font-size: 12px;position: relative">
                    <thead>
                      <tr>
                        <td>S.No</td>
                        <th>User Name</th>
                        <th>Bill</th>
                        <th> Cash</th>
                        <th>Card</th>
                        <th>UPI</th>
                        <th>Cheque</th>
                        <th>Insurance</th>
                        <th>Due/Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of docuserdataList">
                        <td>{{user.sno}}</td>
                        <td>{{user.username}}</td>
                        <td>{{user.bill}}</td>
                        <td>{{user.cash}}</td>
                        <td>{{user.card}}</td>
                        <td>{{user.upi}}</td>
                        <td>{{user.check}}</td>
                        <td>{{user.insurance}}</td>
                        <td>{{user.balance}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <span class="reportsheanding">Diagnosis bill report</span>
                <button class="accordion-button collapsed" style="background: inherit;" type="button"
                  data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                  aria-controls="collapseTwo" (click)="conbillstyle()">

                  <div class="accordinamountcard">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label class="matlabel" #printCRDBRtotal id="printCRDBRtotal" style="margin-top: 7px;"
                          *ngIf="diagtotalAmount == 'NaN' ? '0.00' : diagtotalAmount"><span
                            style="font-weight: 600;">Total : </span> {{diagtotalAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label class="matlabel" #printCRDBRcash id="printCRHBRcash" style="margin-top: 7px;"
                          *ngIf="diagcashAmount == 'NaN' ? '0.00' : diagcashAmount"><span style="font-weight: 600;">Cash
                            : </span>
                          {{diagcashAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label class="matlabel" #printCRDBRcard id="printCRHBRcard" style="margin-top: 7px;"
                          *ngIf="diagcardAmount == 'NaN' ? '0.00' : diagcardAmount"><span style="font-weight: 600;">Card
                            : </span>
                          {{diagcardAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label class="matlabel" #printCRDBRinsurance id="printCRHBRinsurance"
                          style="margin-top: 7px;" *ngIf="diaginsureAmount == 'NaN' ? '0.00' : diaginsureAmount"><span
                            style="font-weight: 600;">Insurance :
                          </span> {{diaginsureAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto" *ngIf="reportType == 'CR'">
                        <mat-label class="matlabel" #printCRDBRupi id="printCRHBRupi" style="margin-top: 7px;"
                          *ngIf="diagupiAmount == 'NaN' ? '0.00' : diagupiAmount"><span
                            style="font-weight: 600;">UPI:</span>
                          {{diagupiAmount}}
                        </mat-label>
                      </div>
                    </div>
                  </div>
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample" [ngClass]="{'success': isSuccessful, 'error': !isSuccessful}">
                <div class="accordion-body">
                  <table *ngIf="reportType == 'CR'" style="font-size: 12px" #printCRDBR id="printCRDBR">
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th style="width:75px">Bill No</th>
                        <th style="width:150px">Created By</th>
                        <th style="width:125px">Created Date</th>
                        <th>In/Out Patient</th>
                        <th>Paitent Name</th>
                        <th>Advance</th>
                        <th>Balance</th>
                        <th style="width: 100px;">Bill Amt</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let sales of diagnosissalesList">
                        <td>{{sales.sno}}</td>
                        <td style="width:75px">{{sales.billing_id}}</td>
                        <td class="align_left" style="width:100px">{{sales.user_name}}</td>
                        <td style="width:125px">{{sales.created_date}}</td>
                        <td>{{sales.patient_type}}</td>
                        <td class="align_left">{{sales.patient_name}}</td>
                        <td>{{sales.advance}}</td>
                        <td>{{sales.balance}}</td>
                        <td style="width: 75px;">{{sales.bill_amount}}</td>
                        <td>{{sales.paid}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <span class="reportsheanding">Pharma sales report</span>
                <button class="accordion-button collapsed" style="background: inherit;" type="button"
                  data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false"
                  aria-controls="collapseThree" (click)="conbillstyle()">
                  <div class="accordinamountcard">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto">
                        <mat-label class="matlabel" style="margin-top: 7px;" #printpharmatotal id="printpharmatotal"
                          *ngIf="pharmatotalAmount == 'NaN' ? '0.00' : pharmatotalAmount">
                          <span style="font-weight: 600;">Amount : </span> {{pharmatotalAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto">
                        <mat-label class="matlabel" style="margin-top: 7px;"
                          *ngIf="pharmacashAmount == 'NaN' ? '0.00' : pharmacashAmount" #printpharmacash
                          id="printpharmacash"><span style="font-weight: 600;">Cash : </span>
                          {{pharmacashAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto">
                        <mat-label class="matlabel" style="margin-top: 7px;"
                          *ngIf="pharmacardAmount == 'NaN' ? '0.00' : pharmacardAmount" #printpharmacard
                          id="printpharmacard"><span style="font-weight: 600;">Card : </span>
                          {{pharmacardAmount}}
                        </mat-label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto">
                        <mat-label class="matlabel" style="margin-top: 7px;"
                          *ngIf="pharmainsureAmount == 'NaN' ? '0.00' : pharmainsureAmount" #printpharmainsurance
                          id="  printpharmainsurance"><span style="font-weight: 600;">Insurance :
                          </span> {{pharmainsureAmount}}
                        </mat-label>
                      </div>

                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-auto">
                        <mat-label class="matlabel" style="margin-top: 7px;"
                          *ngIf="pharmaupiAmount == 'NaN' ? '0.00' : pharmaupiAmount" #printpharmaupi
                          id="printpharmaupi"><span style="font-weight: 600;">UPI:</span>
                          {{pharmaupiAmount}}
                        </mat-label>
                      </div>
                    </div>
                  </div>
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                data-bs-parent="#accordionExample" [ngClass]="{'success': isSuccessful, 'error': !isSuccessful}">
                <div class="accordion-body">
                  <table style="font-size: 12px;margin-left: 5px;width: 155vh;" id="printpharma" #printpharma>
                    <thead>
                      <tr>
                        <th style="width:100px">Bill no</th>
                        <th style="width:140px;text-align: left;">Buyer</th>
                        <th style="width:140px;text-align: left;">Created by</th>
                        <th style="width:140px;">Purchase type</th>
                        <th>Amount</th>
                        <th style="width:150px">Deliver To</th>
                        <th>Bill date</th>
                        <th>Balance</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let sales of pharmasalesList">
                        <td style="width:100px">{{sales.order_id}}</td>
                        <td class="align_left" style="width:140px">{{sales.name}}</td>
                        <td class="align_left" style="width:140px">{{sales.created_by}}</td>
                        <td>{{sales.order_type}}</td>
                        <td style="text-align: right;">{{sales.amount}}</td>
                        <td style="width:150px">{{sales.deliver_to}}</td>
                        <td style="width:100px">{{sales.order_date}}</td>
                        <td style="text-align: right;">{{sales.balance}}</td>
                        <td style="width:100px">{{sales.paid}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-----added by christo--------->

          <!-- mat accordin -->
          <table #printNVR *ngIf="reportType == 'NVR'" id="printNVR" style="font-size: 12px; width: 105%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th style="width: 25%;text-align:left">Name</th>
                <th style="width:19%">Mobile Number</th>
                <th>Session</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td style="width: 25%;text-align:left">{{sales.patientname}}</td>
                <td style="width:10%;text-align:left">{{sales.number}}</td>
                <td>{{sales.session}}</td>
                <td>{{sales.date}}</td>
              </tr>
            </tbody>
          </table>

          <table #printCHBR *ngIf="reportType == 'CHBR'" id="printCHBR" style="font-size: 12px; width: 135%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th style="width:75px">Bill No</th>
                <th style="width:180px">Product</th>
                <th style="width:100px">Batch No</th>
                <th style="width:150px">MRP(On book)</th>
                <th>MRP(Sold)</th>
                <th>Amount</th>
                <th style="width:130px">Sold By</th>
                <th style="width:125px">Date</th>
                <th>Qty Sold</th>
                <th>Qty Onhand</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td style="width:100px">{{sales.bill_no}}</td>
                <td class="align_center">{{sales.product_name}}</td>
                <td>{{sales.batchno}}</td>
                <td>{{sales.mrponbook}}</td>
                <td class="align_left">{{sales.mrpsold}}</td>
                <td class="align_left">{{sales.amount}}</td>
                <td>{{sales.created}}</td>
                <td style="width:125px">{{sales.date}}</td>
                <td>{{sales.sold_qty}}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table class="headerfixed" #printpatreport *ngIf="reportType == 'Patreport'" id="printpatreport"
            style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th style="width:40px">S.no</th>
                <th style="width:270px;text-align: left;">Name</th>
                <th style="width:50px">Mobile no</th>
                <th style="width:50px">Patient Id</th>
                <th style="width:50px">Gender</th>
                <th style="width:50px">Age</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td style="width:270px;text-align: left;">{{sales.name}}</td>
                <td class="align_center">{{sales.MobileNo}}</td>
                <td>{{sales.patId}}</td>
                <td>{{sales.gender}}</td>
                <td>{{sales.age}}</td>
              </tr>
            </tbody>
          </table>
          <table #printSURREPO *ngIf="reportType == 'SURREPO'" id="printSURREPO" style="font-size: 12px; width: 105%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th style="width:150px">Patient Name</th>
                <th>Mobile no</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Doctor</th>
                <th>Surgery</th>
                <th>Surgery Date</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td style="width:150px">{{sales.name}}</td>
                <td class="align_center">{{sales.MobileNo}}</td>
                <td>{{sales.age}}</td>
                <td>{{sales.gender}}</td>
                <td>{{sales.surgonname}}</td>
                <td>{{sales.surgery}}</td>
                <td>{{sales.date}}</td>
              </tr>
            </tbody>
          </table>

          <table #printDBR *ngIf="reportType == 'DBR'" id="printDBR" style="font-size: 12px; width: 150%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th style="width:75px">Bill No</th>
                <th style="width:150px">Created By</th>
                <th style="width:125px">Created Date</th>
                <th>In/Out Patient</th>
                <th>Paitent Name</th>
                <th>Advance</th>
                <th style="width: 100px;">Bill Amt</th>
                <th>Paid</th>
                <th>Cash</th>
                <th>Card</th>
                <th>UPI</th>
                <th>Insurance</th>
                <th>Due/Credit</th>
                <!-- <th>Pay type</th> -->
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td style="width:75px">{{sales.billing_id}}</td>
                <td class="align_left" style="width:100px">{{sales.user_name}}</td>
                <td style="width:125px">{{sales.created_date}}</td>
                <td>{{sales.patient_type}}</td>
                <td class="align_left">{{sales.patient_name}}</td>
                <td>{{sales.advance}}</td>

                <td style="width: 75px;">{{sales.bill_amount}}</td>
                <td>{{sales.paid_amount}}</td>
                <td>{{sales.cash}}</td>
                <td>{{sales.card}}</td>
                <td>{{sales.upi}}</td>
                <td>{{sales.insurance}}</td>
                <td>{{sales.balance}}</td>
                <!-- <td>{{sales.pay_type}}</td> -->
                <td>{{sales.paid}}</td>
              </tr>
            </tbody>
          </table>

          <table #printIR *ngIf="reportType == 'IR'" id="printIR" style="font-size: 12px; width: 105%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Order No</th>
                <th>User Name</th>
                <th>Product Name</th>
                <th>Batch No</th>
                <th>Quantity</th>
                <th>Balance</th>
                <th>Discount</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.order_id}}</td>
                <td class="align_left">{{sales.prop_name}}</td>
                <td class="align_left">{{sales.prod_name}}</td>
                <td>{{sales.batch_no}}</td>
                <td>{{sales.quantity}}</td>
                <td>{{sales.balance}}</td>
                <td>{{sales.discount}}</td>
                <td>{{sales.amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printIPR *ngIf="reportType == 'IPR'" id="printIPR" style="font-size: 12px; width: 105%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>DOA - TOA</th>
                <th>Patient Name</th>
                <th>Age</th>
                <th>Doctor Name</th>
                <th>Bed No</th>
                <th>DOD - TOD</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.admission}}</td>
                <td class="align_left">{{sales.patient_name}}</td>
                <td>{{sales.age}}</td>
                <td class="align_left">{{sales.doctor_name}}</td>
                <td>{{sales.bed_no}}</td>
                <td>{{sales.discharge}}</td>
              </tr>
            </tbody>
          </table>

          <table #printReturnsrepo *ngIf="reportType == 'returnsReport'" id="#printReturnsrepo"
            style="font-size: 12px; width: 105%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Medicine</th>
                <th>Supplier</th>
                <th>Batch No</th>
                <th>Expiry date</th>
                <th>Return qty</th>
                <th>Return Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.product_name}}</td>
                <td>{{sales.Supplier}}</td>
                <td>{{sales.batch}}</td>
                <td>{{sales.expiryDate}}</td>
                <td>{{sales.qty}}</td>
                <td>{{sales.returned_date | date: 'dd-MM-yyyy'}} </td>
              </tr>
            </tbody>
          </table>

          <table #printSRD *ngIf="reportType == 'SRD'" id="printSRD" style="font-size: 12px; width: 105%;">
            <thead>
              <tr *ngIf="this.Filter_by_Id !='Service'">
                <th>S.no</th>
                <th style="width: 45%;">Name</th>
                <th>Count</th>
              </tr>
              <tr *ngIf="this.Filter_by_Id =='Service'">
                <th>S.no</th>
                <th style="width: 45%;">Name</th>
                <th>Count</th>
                <th>Fees</th>
                <th>Amounts</th>
              </tr>
            </thead>
            <tbody *ngIf="this.Filter_by_Id !='Service'">
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td class="align_left">{{sales.name}}</td>
                <td>{{sales.count}}</td>
              </tr>
            </tbody>
            <tbody *ngIf="this.Filter_by_Id =='Service'">
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.name}}</td>
                <td>{{sales.count}}</td>
                <td>{{sales.fee}}</td>
                <td>{{sales.amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printBillRefund *ngIf="reportType =='Bill_refund'" id="printBillRefund"
            style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Bill No</th>
                <!-- <th>Client registration id</th> -->
                <th>Name</th>
                <th>Created Date</th>
                <th>Refund Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td style="padding: 0px 0px;width:1px">{{sales.sno}}</td>
                <td>{{sales.billid}}</td>
                <!-- <td class="align_left">{{sales.client_reg_id}}</td> -->
                <td class="align_left">{{sales.name}}</td>
                <td>{{sales.billdate}}</td>
                <td>{{sales.refund_amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printBillDue *ngIf="reportType =='Bill_due'" id="printBillDue" style="font-size: 12px; width: 100%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Bill No</th>
                <!-- <th>Client registration id</th> -->
                <th>Name</th>
                <th>Created date </th>
                <th>Bill Due</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.billid}}</td>
                <!-- <td >{{sales.client_reg_id}}</td> -->
                <td>{{sales.name}}</td>
                <td>{{sales.bill_date}}</td>
                <td>{{sales.refund_amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printBedOcc *ngIf="reportType =='bed_occupancy'" id="#printBedOcc"
            style="font-size: 12px; width: 95%;">
            <thead>
              <tr *ngIf="bed_occupancyfilter =='ward'">
                <th>S.no</th>
                <th>Ward Name</th>
              </tr>
              <tr *ngIf="bed_occupancyfilter =='bed'">
                <th>S.no</th>
                <th>Ward Name</th>
                <th>Bed Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.wardname}}</td>
                <td>{{sales.bedno}}</td>
              </tr>
            </tbody>
          </table>

          <table #printabc *ngIf="reportType == 'abc_analysis'" id="printabc" style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Product Name</th>
                <th>Quantity</th>
                <th>Sales</th>
                <th>Product Rank</th>
                <th>Product Type</th>
                <th>ABC Analysis</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.product_name}}</td>
                <td>{{sales.quantity}}</td>
                <td>{{sales.sales}}</td>
                <td>{{sales.product_rank}}</td>
                <td>{{sales.type_name}}</td>
                <td>{{sales.ABC}}</td>
              </tr>
            </tbody>
          </table>

          <table #printpurchaseOrder *ngIf="reportType == 'sum_of_purchaseOrder'" id="printpurchaseOrder"
            style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Pharmacy ID</th>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td style="padding: 0px 0px;width:1px">{{sales.sno}}</td>
                <td style="padding: 0px 0px;width:1px">{{sales.po_id}}</td>
                <td style="padding: 0px 0px;width:1px">{{sales.po_date}}</td>
                <td style="padding: 0px 0px;width:1px;text-align: right;">{{sales.amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printproduct id="printproduct" *ngIf="reportType == 'product'" style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Product Name</th>
                <th>Quantity</th>
                <th>Sales Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td style="padding: 0px 0px;width:1px">{{sales.sno}}</td>
                <td class="align_left" style="padding: 0px 0px;width:1px">{{sales.product_name}}</td>
                <td style="padding: 0px 0px;width:1px">{{sales.quantity}}</td>
                <td style="padding: 0px 0px;width:1px; text-align: right;">{{sales.sales_amount}}</td>
              </tr>
            </tbody>
          </table>

          <table #printproductrec *ngIf="reportType == 'product_receivables'" id="printproductrec"
            style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Product Name</th>
                <th>Invoice Number</th>
                <th>Batch Number</th>
                <th>Quantity</th>
                <th>Free Quantity</th>
                <th>Received Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.product_name}}</td>
                <td>{{sales.invoice_no}}</td>
                <td>{{sales.batch_no}}</td>
                <td>{{sales.quantity}}</td>
                <td>{{sales.free_quantity}}</td>
                <td>{{sales.received_date}}</td>
              </tr>
            </tbody>
          </table>

          <table #printlabrepo *ngIf="reportType == 'lab_test_report'" id="printlabrepo"
            style="font-size: 12px; width: 95%;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Billing Id</th>
                <th>Billing Date</th>
                <th>Bill Amount</th>
                <th>Test Name</th>
                <th>Test Type</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sales of salesList">
                <td>{{sales.sno}}</td>
                <td>{{sales.billingid}}</td>
                <td>{{sales.billingdate}}</td>
                <td>{{sales.amount}}</td>
                <td>{{sales.testname}}</td>
                <td>{{sales.testtype}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
</div>